module.exports = __webpack_public_path__ + "media/images/policies/redirect_popup/creditcard-company-1-95998acca9ceb3e40b832ab30f58a6a8.png";